<div class="layout-footer">
    <div class="footer-start">
    </div>
    <div class="footer-end">
        <span>© {{year}} Vision distribution</span>
    </div>
</div>
